export const transform = (options, data, parameters) => data.filter((entry => options.callback(entry, parameters)));
//# sourceMappingURL=filter.js.map
